<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div
        class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch ts-mb-3"
      >
        <input
          v-model="model.text"
          type="text"
          :placeholder="$t('productLabel.searchPurchaseNumber')"
          class="
        ts-px-3
        ts-py-3
        ts-placeholder-blueGray-300
        ts-text-blueGray-600
        ts-relative
        ts-bg-white
        ts-rounded
        ts-text-sm
        ts-border
        ts-outline-none
        focus:ts-outline-none focus:ts-ring
        ts-w-full ts-pr-10
      "
        />
        <span
          class="
        ts-z-10
        ts-h-full
        ts-leading-snug
        ts-font-normal
        ts-absolute
        ts-text-center
        ts-text-blueGray-300
        ts-bg-transparent
        ts-rounded
        ts-text-base
        ts-items-center
        ts-justify-center
        ts-w-8
        ts-right-0
        ts-pr-3
        ts-py-3
      "
        >
          <i class="fas fa-search"></i>
        </span>
      </div>
      <div class="max-h ts-mb-3 ts-mt-3">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-300 ts-px-2 ts-py-1 ts-uppercase">
                {{ $t('productLabel.purchaseInvoiceNumber') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(r, index) in resources"
              :key="index"
              @click="onChoose(r)"
              class="ts-cursor-pointer hover:ts-bg-gray-200"
            >
              <td class="ts-p-2">{{ r.stock_in_number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <small class="ts-font-bold ts-tracking-widest ts-text-yellow-700 ts-mt-3"
        ><i class="fas fa-info-circle"></i>
        {{ $t('productLabel.doubleClickToChooseAnyPurchaseInvoice') }}</small
      >
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'purchaseInvoiceList',
  data() {
    return {
      loading: false,
      model: {
        text: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('product/label', ['resources', 'pagination'])
  },
  methods: {
    ...mapActions('product/label', ['getStockIn']),
    fetchData(attributes) {
      this.loading = true
      this.getStockIn({ ...attributes }).finally(() => {
        this.loading = false
      })
    },
    onChoose(record) {
      this.$emit('choosen', record)
    }
  },
  watch: {
    'model.text': debounce(function(search) {
      this.fetchData({
        filter: {
          search: search
        }
      })
    }, 500)
  }
}
</script>

<style scoped>
.max-h {
  max-height: 500px;
  overflow: scroll;
}
</style>
